import { useCallback, useEffect, useState } from 'react';
import { licenseService } from '../services/licenseService';

export default function useLicenseMetadata({ enabled = true } = {}) {
  const [features, setFeatures] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchMetadata = useCallback(async () => {
    setIsLoading(true);
    setError(null);

    try {
      const featuresRes = await licenseService.getLicenseFeatures();

      setFeatures(
        featuresRes?.status === 200 || featuresRes?.status === 201
          ? (Array.isArray(featuresRes.data) ? featuresRes.data : [])
          : []
      );
    } catch (err) {
      setFeatures([]);
      setError(err?.message || 'Failed to load license metadata');
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    if (enabled) {
      fetchMetadata();
    }
  }, [enabled, fetchMetadata]);

  return {
    features,
    isLoading,
    error,
    refetch: fetchMetadata,
  };
}
